import documents from "./documents.json";
export type LegalKind = "terms" | "privacy";
export type LegalLanguage = "it" | "en" | "es";
export const LEGAL_VERSION = "2026-10-07";
export function legalDocument(kind: LegalKind, language: string) { return documents[language === "it" || language === "es" ? language : "en"][kind]; }
export function legalAcceptanceCurrent(value: unknown, uid: string): boolean {
  if (!value || typeof value !== "object" || !uid) return false;
  const receipt = value as Record<string, unknown>;
  const language = receipt.language;
  if (language !== "it" && language !== "en" && language !== "es") return false;
  const timestamp = receipt.acceptedAt as { toMillis?: () => number } | undefined;
  if (!timestamp || typeof timestamp.toMillis !== "function" || !Number.isFinite(timestamp.toMillis()) || timestamp.toMillis() <= 0) return false;
  return receipt.uid === uid && receipt.termsAccepted === true && receipt.privacyAcknowledged === true
    && receipt.termsRead === true && receipt.privacyRead === true
    && receipt.termsVersion === LEGAL_VERSION && receipt.privacyVersion === LEGAL_VERSION
    && receipt.termsHash === documents[language].terms.hash && receipt.privacyHash === documents[language].privacy.hash
    ;
}
